import React, { useState, useEffect } from "react";

import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../../services/reports-Diamond.service";
import { useSelector } from "react-redux";
import moment from "moment";
import { Spin, Tooltip } from "antd";
import Chart from "react-google-charts";

const DiamondReportsShapeComp = ({
  globalDiamonds,
  isApplyFilter,
  mainForDealer,
}) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondShapeSearchesLabels, setDiamondShapeSearchesLabels] = useState(
    []
  );
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [DiamondShapeColorData, setDiamondShapeColorData] = useState([]);
  const [DiamondShapeYAxisList, setDiamondShapeYAxisList] = useState([]);
  const [key, setKey] = useState(true);
  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          handleLoadExtendedDiamondChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  /*API Binding Starts*/

  const handleLoadExtendedDiamondChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);

      ReportsDiamondService.LoadExtendedDiamondChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var DiamondShapeSearchesList = responseData.DiamondShapeSearches;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              var DiamondShapeSearchesLabelArr = DiamondShapeSearchesList.map(
                (item) => {
                  return item.Cut;
                }
              );
              var DiamondShapeYAxisList = DiamondShapeSearchesList.map(
                (item) => {
                  return item.CNT;
                }
              );
              setDiamondShapeSearchesLabels(DiamondShapeSearchesLabelArr);
              setDiamondShapeYAxisList(DiamondShapeYAxisList);
              diamondShapeColorHandler(DiamondShapeSearchesLabelArr);
              setKey(!key);
            }
          } else {
            setDiamondShapeYAxisList([]);
          }
        })
        .catch((error) => {
          setLoadChartReportsLoading(false);
          setDiamondShapeYAxisList([]);
          setDiamondShapeSearchesLabels([]);
        });
    } catch (error) {
      setLoadChartReportsLoading(false);
      setDiamondShapeYAxisList([]);
      setDiamondShapeSearchesLabels([]);
    }
  };
  /*API Binding Ends*/

  const diamondShapeColorHandler = (list) => {
    const color = [];
    for (let i = 0; i < list.length; i++) {
      color.push("rgb(66, 133, 244)");
    }
    setDiamondShapeColorData(color);
  };

  const chartData = [
    ["Shape", "Count", { role: "style" }],
    ...diamondShapeSearchesLabels.map((label, index) => [
      label,
      DiamondShapeYAxisList[index],
      DiamondShapeColorData[index],
    ]),
  ];

  const options = {
    legend: { position: "none" },
    bar: { groupWidth: "60%" },
    chartArea: { width: "90%", height: "75%" },
    hAxis: {
      title: "Shape",
      textStyle: { fontSize: 12 },
    },
    vAxis: {
      title: "Count",
      titleTextStyle: {
        fontSize: 16,
        color: "rgb(66, 66, 66)",
      },
      textStyle: { fontSize: 12 },
    },
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b> {t("Diamond Shape Searches")} </b>
        </label>
        <div className="chart__section">
          <Spin spinning={LoadChartReportsLoading} size="large">
            {/* <Bar
              key={key}
              data={{
                labels: diamondShapeSearchesLabels,
                datasets: [
                  {
                    label: "Count",
                    data: DiamondShapeYAxisList,
                    backgroundColor: DiamondShapeColorData,
                    borderColor: DiamondShapeColorData,
                    borderWidth: 1,
                  },
                ],
              }}
              width={300}
              height={300}
              options={{
                scales: {
                  x: {
                    title: {
                      color: "rgb(66, 66, 66)",
                      display: true,
                      text: "Shape",
                      font: {
                        size: 16,
                      },
                    },
                  },
                },
                maintainAspectRatio: false,
                responsive: true,
                onClick: function (evt, element) {},
                plugins: {
                  datalabels: {
                    display: false,
                  },
                  legend: {
                    display: false,
                  },
                },
              }}
            /> */}
            <div>
              {diamondShapeSearchesLabels.length > 0 && (
                <Chart
                  chartType="ColumnChart"
                  data={chartData}
                  options={options}
                  width={window.innerWidth > 500 ? "100%" : 300}
                  height={window.innerWidth > 500 ? 600 : 300}
                />
              )}
              {!LoadChartReportsLoading && diamondShapeSearchesLabels.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                  {t("No data available")}
                </div>
              )}
            </div>
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsShapeComp;
